import removeClassStartingWith from 'core/DOM/removeClassStartingWith'
import toggleClass from 'utils/DOM/toggleClass'

function showStep(id) {
  removeClassStartingWith(document.body, 'step')
  toggleClass(document.body, id, true)
}

export default showStep
